module.exports = "https://static.wmbcdn.com/uniweb/images/9eb0adf17a12cf3a57f56c7a85abe98b.svg";